import React, {Component} from "react";
import {View, Image, TouchableOpacity, FlatList, ScrollView} from 'react-native'
import {icons} from "../theme/icons";
import {appStyles} from '../theme/styles'
import TextView from "../components/TextView";
import ServiceItem from "../components/ServiceItem";
import {servicesRequest} from "../utils/api";
import Waiting from "../components/Waiting";

export default class ServiceListScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            waiting: true,
            search: '',
            parts: []
        }
    }

    _keyExtractor = (item, index) => index.toString();

    renderRow({item, index}) {
        return <ServiceItem data={item} navigation={this.props.navigation}/>
    }

    renderSlider({item, index}) {
        return <View>
            <FlatList
                data={item}
                key={index}
                contentContainerStyle={{justifyContent: 'space-around'}}
                keyExtractor={this._keyExtractor}
                numColumns={3}
                renderItem={this.renderRow.bind(this)}
            />
        </View>
    }

    render() {
        return (<View style={appStyles.flex1}>
            <ScrollView>
                <View style={appStyles.toolbarWraper}>
                    <Image source={icons['ad']} style={[appStyles.toolbarIcon, {tintColor: '#31BFCF'}]}/>
                    <TextView style={appStyles.toolbarTitle}>انتخاب خدمت</TextView>
                    <TouchableOpacity onPress={() => {
                        this.props.navigation.goBack()
                    }}>
                        <Image source={icons['back']} style={appStyles.backIcon}/>
                    </TouchableOpacity>
                </View>


                <FlatList
                    data={this.state.parts}
                    renderItem={this.renderSlider.bind(this)}
                    keyExtractor={this._keyExtractor}
                    horizontal={true}
                    showsVerticalScrollIndicator={false}
                    snapToAlignment={"start"}
                    decelerationRate={"fast"}
                    pagingEnabled
                />
            </ScrollView>

            <Waiting waiting={this.state.waiting}/>

        </View>)
    }

    componentWillMount() {
        servicesRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                var data = response.data;
                data.sort((a, b) => {
                    if (a.priority < b.priority) {
                        return -1;
                    }
                    if (b.priority > a.priority) {
                        return 1;
                    }
                    return 0;
                })
                var parts = [];
                if (data.length > 8) {
                    parts.push(data.slice(0, 9))
                } else {
                    parts.push(data.slice(0, data.length))
                }
                if (data.length > 17) {
                    parts.push(data.slice(9, 18))
                } else if (data.length <= 17 && data.length > 9) {
                    parts.push(data.slice(9, data.length))
                }
                if (data.length > 18) {
                    parts.push(data.slice(18, data.length))
                }
                console.log(parts)
                this.setState({
                    data: data,
                    parts: parts
                })
            }
        })
    }

}
